import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { size, clone, keys, map, get } from 'lodash'
import { useHistory, useParams } from "react-router-dom"
import { useForm, Controller } from 'react-hook-form'
import { Map } from "./layout/Map"
import { showSuccess, showError } from '../v2_actions/error'
import { yupResolver } from '@hookform/resolvers/yup'
import { loggedInUser } from '../v2_actions/auth'
import { PageLayout } from './layout/PageLayout'
import {Box, Grid, Button, Tooltip, Typography,
        MenuItem, Snackbar, InputAdornment,
        IconButton, makeStyles
       } from "@material-ui/core"
import { getPriceByGid } from "../apis"
import { photographList } from '../v2_actions/photograph'
import { galleryList } from '../v2_actions/gallery'
import { getDefaultLocationForUser, setMapCenter } from '../v2_actions/map'

const useStyles = makeStyles({
})

export const MapView = ({match}) => {

    const classes = useStyles()
    const dispatch = useDispatch()
    const history = useHistory()
    const { gallery_id } = useParams()
    const galleries = useSelector(() => galleryList.getVisibleObjects())
    const gallery = useSelector(() => galleryList.getObject(gallery_id))
    const is_ready = !gallery_id || get(gallery, "id")
    
    useEffect(() => {
        dispatch(galleryList.updatePaginationNumItemsPerPage(1000))
    }, [])

    useEffect(() => {
        if ( get(gallery, "lat") && get(gallery, "lng") ) {
            dispatch(setMapCenter({lat: get(gallery, "lat"), lng: get(gallery, "lng")}))
        }
    }, [get(gallery, "id")])
    
    useEffect(() => {
        dispatch(galleryList.fetchListIfNeeded())
        if ( gallery_id ) {
            dispatch(galleryList.ensureObjectLoaded(gallery_id))
        }
    }, [gallery_id])

    const onSelectGallery = (gallery_id) => {
        history.push(`/photographer/gallery/${gallery_id}/view`)
    }

    return (

        <PageLayout gallery={gallery}>
          <div
            style={{
                height: "100vh",
                width: "100%",
            }}
          >
            { is_ready && 
              <Map markers={map(galleries, function(gallery) {
                  return {
                      imageUrl: galleryList.getGalleryAvatarUrl(gallery),
                      name: gallery.gallery_name,
                      position: {lat: gallery.lat, lng: gallery.lng},
                      onClick: () => onSelectGallery(gallery.id)
                  }
              })}
              />
            }
          </div>
          
        </PageLayout>
    )
    
}
